// @flow
import actions from "./actions";
import type {Dispatch} from "redux";
import type {StopRequest} from "./utils";
import {LatLngEnum, StopEnum as StopTypeEnum} from "../../../Utils/AppUtils";
import {registerMiddleman} from "../../Middleware/Middleman/middleware";
import MapDataSelectors from "../MapData/selectors";
import TokenDataSelectors from "../TokenData/selectors";
import BackendOperations from "../../Middleware/Backend/operations";
import BackendTypes from "../../Middleware/Backend/types";
import type {GetState} from "../../Store";
import {getManualSelectionPolygonIfManualSelection, StopSelection} from "./utils";
import AppOperations from "../App/operations";
import selectors from "./selectors";
import MapDataOperations from "../MapData/operations";


const selectOrigin = (payload: StopRequest) => {
    return (dispatch: Dispatch, getState: GetState) => {
        const state = getState();
        const dest = selectors.getDest(state);
        dispatch(MapDataOperations.panToLatlng({lat: dest.lat, lng: dest.lng}));
        return dispatch(actions.selectOrigin({
            label: payload.label,
            latlng: payload.latlng || MapDataSelectors.getMapCenter(state),
            selection: payload.selection || StopSelection.MANUAL,
        }));
    };
};

const freeSelectionOrigin = (payload: StopRequest) => {
    return (dispatch: Dispatch, getState: GetState) => {
        const state = getState();
        const airportPolygon = getManualSelectionPolygonIfManualSelection(state);
        if (airportPolygon) {
            return dispatch(BackendOperations.doGetPolygonStops(airportPolygon.id, StopTypeEnum.PICKUP));
        } else {
            return dispatch(selectOrigin({
                label: payload.label,
                latlng: payload.latlng || MapDataSelectors.getMapCenter(state),
                selection: StopSelection.FREE,
            }));
        }
    };
};

const selectDest = (payload: StopRequest) => {
    return (dispatch: Dispatch, getState: GetState) => {
        return dispatch(actions.selectDest({
            label: payload.label,
            latlng: payload.latlng || MapDataSelectors.getMapCenter(getState()),
            selection: payload.selection || StopSelection.MANUAL,
        }));
    };
};

const freeSelectionDest = (payload: StopRequest) => {
    return (dispatch: Dispatch, getState: GetState) => {
        const state = getState();
        const airportPolygon = getManualSelectionPolygonIfManualSelection(state);
        if (airportPolygon) {
            return dispatch(BackendOperations.doGetPolygonStops(airportPolygon.id, StopTypeEnum.DROPOFF));
        } else {
            return dispatch(selectDest({
                label: payload.label,
                latlng: payload.latlng || MapDataSelectors.getMapCenter(state),
                selection: StopSelection.FREE,
            }));
        }
    };
};

const clickOriginLabel = () => {
    return (dispatch: Dispatch, getState: GetState) => {
        const state = getState();
        const origin = selectors.getOrigin(state);
        dispatch(actions.clickOriginLabel());
        dispatch(MapDataOperations.panToLatlng({lat: origin.lat, lng: origin.lng}));
    };
};
const clickDestLabel = actions.clickDestLabel;
const selectOriginSuggestion = actions.selectOriginSuggestion;
const selectDestSuggestion = actions.selectDestSuggestion;
const cancelSearchClick = actions.cancelSearchClick;
const updateOriginLatlng = actions.updateOriginLatlng;
const updateDestLatlng = actions.updateDestLatlng;
const updateOriginAddress = actions.updateOriginAddress;
const updateDestAddress = actions.updateDestAddress;


const invalidateRequestDestOrOrigin = () => {
    return (dispatch: Dispatch, getState: GetState) => {
        const state = getState();
        const destType = TokenDataSelectors.getDestType(state);
        const originType = TokenDataSelectors.getOriginType(state);
        if (destType !== LatLngEnum.FORCE_EXACT) {
            dispatch(actions.invalidateDest());
            dispatch(MapDataOperations.panToLatlng(selectors.getDest(state)))
        } else if (originType !== LatLngEnum.FORCE_EXACT) {
            dispatch(actions.invalidateOrigin());
            dispatch(MapDataOperations.panToLatlng(selectors.getOrigin(state)))
        } else {
            dispatch(AppOperations.noOperation());// should be unreachable
        }
    };
};
registerMiddleman(BackendTypes.MIDDLEMAN_INVALIDATE_REQUEST, invalidateRequestDestOrOrigin);

const cancelOriginTerminalSelectionClick = actions.cancelOriginTerminalSelectionClick;
const cancelDestTerminalSelectionClick = actions.cancelDestTerminalSelectionClick;


export default {
    selectOrigin,
    freeSelectionOrigin,
    selectDest,
    freeSelectionDest,
    selectOriginSuggestion,
    selectDestSuggestion,
    clickOriginLabel,
    clickDestLabel,
    cancelSearchClick,
    updateOriginLatlng,
    updateDestLatlng,
    updateOriginAddress,
    updateDestAddress,
    invalidateRequestDestOrOrigin,
    cancelOriginTerminalSelectionClick,
    cancelDestTerminalSelectionClick,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRequest/operations.js